/**
 * Строка операции в «Счетах и выписках»: откуда пришла операция, короткая подпись статьи
 * ДДС и номер счёта «…1234» — чтобы строка платежа не вырастала в пять строк. Полные
 * подписи и номер остаются в подсказке. Модуль без импортов значений — проверяется
 * node:test (`paymentView.test.mjs`).
 */

/** Откуда операция (`ceo_bank_payments.source`). */
const SOURCE_LABELS: Record<string, string> = {
  bank_api: 'Банк',
  '1c_exchange': 'Выписка 1С',
  manual: 'Вручную',
  econ_sync: 'Экономист',
};

export function paymentSourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? 'Другой источник';
}

/** Статья ДДС коротко — для колонки таблицы; полная подпись — в подсказке. */
const CATEGORY_SHORT_LABELS: Record<string, string> = {
  ks3_receipt: 'Оплата по КС-3',
  advance_receipt: 'Аванс заказчика',
  retention_receipt: 'Возврат удержания',
  other_inflow: 'Прочие поступления',
  internal_transfer: 'Между своими счетами',
  materials: 'Материалы',
  fuel: 'ГСМ',
  subcontract: 'Субподряд',
  payroll: 'ФОТ',
  taxes: 'Налоги',
  debt_service: 'Кредиты и проценты',
  leasing: 'Лизинг',
  equipment: 'Оборудование',
  logistics: 'Логистика',
  overhead: 'Накладные',
  other: 'Прочие платежи',
};

export function categoryShortLabel(category: string): string | undefined {
  return CATEGORY_SHORT_LABELS[category];
}

/** Номер счёта в таблице — последние четыре цифры: «…1234». */
export function accountTail(accountNumber: string | null | undefined): string {
  const number = (accountNumber ?? '').replace(/\s/g, '');
  return number.length > 4 ? `…${number.slice(-4)}` : number;
}
